/**
 * #359: the primary email address is entered as the part before @ plus one of the customer's
 * own domains, so a new account cannot get a misspelt or foreign domain.
 */

const isRoutingDomain = (domain) => domain.endsWith(".onmicrosoft.com");

/**
 * The customer's own email domains: the tenant's domain first, then the domains its users'
 * addresses already use. Microsoft's onmicrosoft.com routing domains are left out — unless
 * the customer has no other domain, so a tenant without a custom domain can still onboard.
 *
 * @param {string} tenantDomain - The tenant's primary domain, e.g. "diflex.se"
 * @param {object[]} users - The users whose addresses count (callers leave out rooms and the like)
 * @returns {string[]} Distinct domains, the tenant's own first
 */
export const customerEmailDomains = (tenantDomain, users) => {
  const primary = (tenantDomain || "").trim().toLowerCase();
  const inUse = (Array.isArray(users) ? users : [])
    .map((user) => ((user.email || "").split("@")[1] || "").trim().toLowerCase())
    .sort();

  const domains = [...new Set([primary, ...inUse].filter(Boolean))];
  const customDomains = domains.filter((domain) => !isRoutingDomain(domain));
  return customDomains.length > 0 ? customDomains : domains;
};

/**
 * @param {string} chosen - The domain the orderer picked, if any
 * @param {string[]} options - The customer's domains
 * @returns {string} The domain in use: the orderer's choice, otherwise the customer's first
 */
export const effectiveEmailDomain = (chosen, options) => chosen || options[0] || "";

/**
 * @param {string} localPart - The part before @ as typed
 * @param {string} domain - The domain in use
 * @returns {string} "anna.andersson@diflex.se", or "" until both parts are there
 */
export const joinEmail = (localPart, domain) => {
  const local = (localPart || "").trim();
  return local && domain ? `${local}@${domain}` : "";
};
